<template>
  <button @click="handleClick" class="btn btn-raised copy-to-clipboard-btn" :class="{'recently-clicked': recentlyClicked}">
    <span v-if="!recentlyClicked">
      <i class="material-icons">content_paste</i>
      <div>Copy to clipboard</div>
    </span>
    <span v-if="recentlyClicked" style="width:100%;">
      <i class="material-icons">check</i>
      <div style="display:flex; flex-grow:1; justify-content:center;">Copied!</div>
    </span>
  </button>
</template>

<script>
export default {
  name: 'CopyBtn',
  data () {
    return {
      recentlyClicked: false
    }
  },
  methods: {
    handleClick () {
      this.$emit('click');
      this.recentlyClicked = true;
      setTimeout(() => {
        this.recentlyClicked = false;
      }, 3000);
    }
  }
}
</script>

<style lang="scss">
  .mb-widget {
    .copy-to-clipboard-btn { background-color:#ffffff; transition: all .5s;
      &.recently-clicked { background-color:rgb(76, 175, 80); border-color:#4caf50; color:white; }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/CopyBtn.vue